var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTVpersonalities1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -51.2,
    y: -51.2,
    width: 614.4,
    height: 614.4,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.467,221.867H460.8v-59.733c0-24.644-12.015-47.974-32.137-62.396c-2.961-2.133-6.972-2.133-9.941-0.009 c-5.436,3.9-11.46,6.682-17.732,8.508l15.71,23.561c1.826,2.748,1.911,6.298,0.213,9.131l-25.6,42.667 c-1.536,2.569-4.318,4.139-7.313,4.139c-2.995,0-5.777-1.57-7.313-4.139l-25.6-42.667c-1.698-2.833-1.613-6.383,0.213-9.131 l15.71-23.561c-6.272-1.826-12.297-4.608-17.732-8.508c-2.978-2.125-6.98-2.125-9.941,0.009 c-20.122,14.421-32.137,37.751-32.137,62.396v59.733H204.8v-59.733c0-24.644-12.015-47.974-32.137-62.396 c-2.961-2.133-6.972-2.133-9.941-0.009c-5.436,3.9-11.46,6.682-17.732,8.508l15.71,23.561c1.826,2.748,1.911,6.298,0.213,9.131 l-25.6,42.667c-1.536,2.569-4.318,4.139-7.313,4.139s-5.777-1.57-7.313-4.139l-25.6-42.667c-1.698-2.833-1.613-6.383,0.213-9.131 l15.71-23.561c-6.272-1.826-12.297-4.608-17.732-8.508c-2.978-2.125-6.98-2.125-9.941,0.009 C63.215,114.159,51.2,137.489,51.2,162.133v59.733H8.533C3.814,221.867,0,225.69,0,230.4v34.133c0,4.71,3.814,8.533,8.533,8.533 h8.533v230.4c0,4.71,3.814,8.533,8.533,8.533h460.8c4.719,0,8.533-3.823,8.533-8.533v-230.4h8.533 c4.719,0,8.533-3.823,8.533-8.533V230.4C512,225.69,508.186,221.867,503.467,221.867z M256,477.867 c-51.755,0-93.867-42.112-93.867-93.867c0-51.755,42.112-93.867,93.867-93.867c51.755,0,93.867,42.112,93.867,93.867 C349.867,435.755,307.755,477.867,256,477.867z M494.933,256H486.4H25.6h-8.533v-17.067h42.667h136.533h119.467h136.533h42.667 V256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,102.4c28.237,0,51.2-22.963,51.2-51.2S156.237,0,128,0S76.8,22.963,76.8,51.2S99.763,102.4,128,102.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.496,136.775 128.001,162.614 143.506,136.775 131.969,119.469 124.033,119.469 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,102.4c28.237,0,51.2-22.963,51.2-51.2S412.237,0,384,0c-28.237,0-51.2,22.963-51.2,51.2S355.763,102.4,384,102.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.496,136.775 384.001,162.614 399.506,136.775 387.969,119.469 380.033,119.469 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.533,310.226v65.237H293.7C291.499,343.455,277.282,318.537,264.533,310.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.467,457.774v-65.237H218.3C220.501,424.545,234.718,449.463,247.467,457.774z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.533,392.533v65.237c12.749-8.311,26.965-33.229,29.167-65.237H264.533z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.205,316.865c9.583,15.514,16.222,36.318,17.587,58.598h21.504C329.489,350.239,314.428,328.675,293.205,316.865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.465,375.467v-65.237c-12.749,8.311-26.965,33.229-29.167,65.237H247.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.795,316.865c-21.222,11.81-36.284,33.374-39.091,58.598h21.504C202.573,353.183,209.212,332.378,218.795,316.865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.703,392.533c2.807,25.225,17.869,46.788,39.091,58.598c-9.583-15.514-16.222-36.318-17.587-58.598H179.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.205,451.135c21.222-11.81,36.284-33.374,39.091-58.598h-21.504C309.427,414.817,302.788,435.622,293.205,451.135z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTVpersonalities1);
export default __webpack_public_path__ + "static/media/TVpersonalities1.3e12858991dffd464369205c15c153be.svg";
export { ForwardRef as ReactComponent };